import { useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { AgentActionsList } from 'widgets/AgentActions'
import { type ChatbotAction } from 'pages/chatbot/store/chatbotActionStore'
import { makeChatbotActionsErrorsAdapter } from 'pages/chatbot/ui/ChatbotEdit/ChatbotActions/errorsAdapter'
import { ACTION_ITEMS, ACTIONS_CONFIG } from './config'

type IGoalActionsProps = {
  actions: ChatbotAction | null
}

export const GoalActions = observer(({ actions }: IGoalActionsProps) => {
  const errors = useMemo(
    () => (actions ? makeChatbotActionsErrorsAdapter(actions.actionErrors) : null),
    [actions?.actionErrors]
  )

  if (!actions || !errors) return null

  return (
    <AgentActionsList
      control={actions}
      errors={errors}
      actionItems={ACTION_ITEMS}
      actionsConfig={ACTIONS_CONFIG}
    />
  )
})
